import React from 'react';
import moment from 'moment';
import './App.css';

function VehicleDetails({ vehicle, onClose, printReceipt, toggleBody, imageFullScreen }) {
  return (
    <div style={{ padding: 5, backgroundColor: '#000000aa', position: 'fixed', top: 0, left: 0, bottom: 0, right: 0, zIndex: 11 }}>
      <div className="modal" style={{ overflowY: 'scroll', maxHeight: '90%', scrollbarWidth: 'none' }}>
        <h2>Moshina axbaroti</h2>
        <div className="vehicle-details">
          <p><strong>ID:</strong> {vehicle.vehicle_id}</p>
          <p><strong>Turi:</strong> {vehicle.type}</p>
          {vehicle.comment && (<p><strong>Kommentariy</strong> {vehicle.comment}</p>)}
          <p><strong>Raqami:</strong> {vehicle.number || 'Kiritilmagan'}</p>
          <p><strong>Kirgan vaqt:</strong> {moment(vehicle.entry_date).format('DD.MM.YYYY HH:mm')}</p>
          {vehicle.status === 'Chiqdi' && (
            <>
              <p><strong>Chiqgan vaqt:</strong> {moment(vehicle.exit_date).format('DD.MM.YYYY HH:mm')}</p>
              <p><strong>Tolangan summa:</strong> {vehicle.paid_amount} so'm</p>
            </>
          )}
        </div>
        {vehicle.photo_url && ( <img src={vehicle.photo_url} alt="Foto mashina" className="preview-image" onClick={imageFullScreen} /> )}
        <div className="modal-buttons">
          <button onClick={() => printReceipt(vehicle)}>Chek chiqarish</button>
          <button className="cancel" onClick={()=>{onClose(); toggleBody();}}>Yopish</button>
        </div>
      </div>
    </div>
  );
}

export default VehicleDetails;